import { Subscription } from 'rxjs';
import { Component, Inject } from "@angular/core";

import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnackbarService } from './../../services/snackbar.service';
import { LtrErrorPopupService } from './ltr-error-popup.service';

@Component({
    selector: "ltr-error-popup",
    template: require('./ltr-error-popup.component.html'),
    styles: [require('./ltr-error-popup.component.less')],
    providers: [LtrErrorPopupService, SnackbarService],
})
export class LtrErrorPopupComponent {
    popupLoading: boolean;
    reviseApiSubscription: Subscription;

    constructor(
        public ltrErrorPopup: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _ltrErrorPopupService: LtrErrorPopupService,
        private _mdlSnackbarService: SnackbarService,
    ) { }

    closePopup() {
        this.ltrErrorPopup.close();
    }

    revise() {
        this.popupLoading = true;
        this.reviseApiSubscription?.unsubscribe();
        this.reviseApiSubscription = this._ltrErrorPopupService.revisePlan(this.data.planId)
            .subscribe(res => {
                this.popupLoading = false;
                this._mdlSnackbarService.showSnackbar('TREATMENT_REVISED', 'success');
                this.ltrErrorPopup.close('revived');
            },
                error => {
                    this.popupLoading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.closePopup();
                });
    }

    ngOnDestroy() {
        this.reviseApiSubscription?.unsubscribe();
    }
}
